
/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './loanclosingtimeline.css';
import parse from 'html-react-parser';

function LoanClosingTimeline({ data }) {
  // If no data is provided, don't render the component
  if (!data) return null;
  const { title, subtitle, costs, bottomdisc } = data;

  // Safe parsing function to handle undefined content
  const safeParse = (content) => {
    if (content === undefined || content === null) return '';
    return parse(content.toString());
  };

  return (
    <div className="loan-closing-timeline-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={12} className="text-center mb-3">
            <h2 className="loan-closing-title">{safeParse(title)}</h2>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={12} className="text-center mb-4">
            <p className="loan-closing-subtitle">{safeParse(subtitle)}</p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="costs-card">
            {costs.title && (
            <div className="costs-header">
              <h3 className="costs-title">{safeParse(costs.title)}</h3>
            </div>
          )}

              <div className="costs-content">
                <p className="costs-description">{safeParse(costs.description)}</p>

                <ul className="costs-list">
                  {costs.items && costs.items.map((item, index) => (
                    <li key={index} className="costs-item">
                      {safeParse(item.text)}

                      {item.subItems && (
                        <ul className="sub-costs-list">
                          {item.subItems.map((subItem, subIndex) => (
                            <li key={subIndex} className="sub-costs-item">
                              {safeParse(subItem.text)}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
        </Row>

        {data.bottomdisc && (
          <Row className="justify-content-center mt-1">
            <Col lg={12} className="text-center">
              <h2 className="construction-title">{safeParse(bottomdisc.title)}</h2>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default LoanClosingTimeline;